/**
 * i18n Configuration - Frontend
 * Többnyelvű felület (magyar/angol)
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import huTranslations from './locales/hu.json';
import enTranslations from './locales/en.json';

i18n.use(initReactI18next).init({
  resources: {
    HU: { translation: huTranslations },
    EN: { translation: enTranslations },
  },
  lng: 'HU', // Default nyelv
  fallbackLng: 'HU',
  interpolation: {
    escapeValue: false, // React már escape-eli
  },
});

export default i18n;
